export default "__VITE_ASSET__DaA6ENTF__"